<template>
  <div>
    <v-textarea class="textarea" v-model="observaciones" label="Observación" :error-messages="this.getRequiredErrors('observaciones')" ref="observacionText">
    </v-textarea>
    <v-btn v-if="!hideSubmit" color="primary" @click="createObservacion" :disabled="saving">Agregar Observación</v-btn>
  </div>
</template>

<script>

import { createEntityMixin } from '../../../mixins/createEntityMixin'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {

  mixins: [
    createEntityMixin,
    validationMixin
  ],

  props: {
    dialogRechazo: Boolean,
    hideSubmit: {
      type: Boolean,
      default: false
    },
    createPath: String,
    payloadId: String,
    id: [String, Number]
  },

  validations: {
    observaciones: { required }
  },

  methods: {
    cerrarModal () {
      this.$emit('cerrarModal')
    },

    getPayload () {
      const payload = {
        'observacion': this.observaciones,
        [this.payloadId]: this.id
      }
      return payload
    },

    createObservacion () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.saving = true
        this.axios
          .post(this.createPath, this.getPayload())
          .then(() => {
            this.saving = false
            this.$emit('observacionCreada', true)
            this.observaciones = null
            this.$v.$reset()
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.saving = false
          })
      }
    }
  },

  computed: {
    observacionSinGuardar () {
      return this.observaciones != null && this.observaciones !== ''
    }
  },

  data () {
    return {
      observaciones: null,
      saving: false
    }
  }
}
</script>
<style scoped>
  .textarea {
    margin: 1em;
    padding: 1em;
    background-color: lightgrey;
    border: 1px solid;
    border-radius: 5px;
  }
</style>
